import React from 'react';
import { Check } from 'lucide-react';
import { toBn } from '../../utils/bn';
const cngSteps = ['ধরন', 'গাড়ির তথ্য', 'কাগজপত্র', 'BRTA', 'নিশ্চিতকরণ'];
export function FlowSteps({
  current
}: {
  current: number;
}) {
  return <ol className="flex items-start bg-white px-3 pb-3 pt-3 shadow-sm" aria-label="নিবন্ধনের ধাপ" data-id="element-1262" data-mp="3d4vl3xnpv80p">
      {cngSteps.map((s, i) => {
      const done = i < current;
      const on = i === current;
      return <li key={s} className="relative flex flex-1 flex-col items-center text-center" data-id="element-1263" data-mp="34737qz1k2afy" data-mpi={i}>
            {i > 0 && <span className={`absolute right-1/2 top-3.5 h-0.5 w-full ${i <= current ? 'bg-bdgreen-600' : 'bg-slate-200'}`} aria-hidden data-id="element-1264" data-mp="384hdggq12037" />}
            <span className={`relative z-10 flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold ${done ? 'bg-bdgreen-600 text-white' : on ? 'bg-navy-800 text-white ring-4 ring-navy-100' : 'bg-slate-200 text-slate-500'}`} data-id="element-1265" data-mp="2z5dtlaj1dgnn">
              {done ? <Check className="h-4 w-4" strokeWidth={3} data-id="element-1266" data-mp="5dnm1bpeunad" /> : toBn(i + 1)}
            </span>
            <span className={`mt-1 text-[10px] font-medium ${on ? 'text-navy-900' : 'text-slate-500'}`} data-id="element-1267" data-mp="fvuwjwlb578">{s}</span>
          </li>;
    })}
    </ol>;
}